import type { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import {
  OverridableQuery,
  serialize,
  useQuery,
  UseQueryOptions,
} from '@wyz/utils';

import { ConnectQueryKeys } from '~/connect/api';
import { useApi } from '~/common/context';
import { IEcotaxZone } from '~/connect/types';
import { PAGINATE_ALL_LIMIT } from '~/common/helpers';

type Options = {
  getAll?: OverridableQuery<
    UseQueryOptions<ISuccessApiResponse<IEcotaxZone[]>, IErrorApiResponse>
  > & {
    args?: {
      countryId?: number;
    };
  };
};

export const useManageEcotaxesZones = (options: Options) => {
  const { callCoreApi } = useApi();

  return useQuery<ISuccessApiResponse<Array<IEcotaxZone>>>({
    queryKey: ConnectQueryKeys.ecotaxesZones.base(
      options.getAll?.args?.countryId,
    ),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<Array<IEcotaxZone>>>(
        `/settings/api/countries/${
          options?.getAll?.args?.countryId as number
        }/ecotax-zones?${serialize({ limit: PAGINATE_ALL_LIMIT })}`,
        {},
      ),
    gcTime: Infinity,
    staleTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    enabled: Boolean(options?.getAll?.args?.countryId),
  });
};
